var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 1.75C8.49594 1.75 5.25 4.99594 5.25 9H3.75C3.75 4.16751 7.66751 0.25 12.5 0.25C17.3325 0.25 21.25 4.16751 21.25 9H19.75C19.75 4.99594 16.5041 1.75 12.5 1.75Z",
    fill: "#001D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 11C1.75 9.48122 2.98122 8.25 4.5 8.25H7.25V17.75H4.5C2.98122 17.75 1.75 16.5188 1.75 15V11ZM4.5 9.75C3.80964 9.75 3.25 10.3096 3.25 11V15C3.25 15.6904 3.80964 16.25 4.5 16.25H5.75V9.75H4.5Z",
    fill: "#001D3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 11C23.25 9.48122 22.0188 8.25 20.5 8.25H17.75V17.75H20.5C22.0188 17.75 23.25 16.5188 23.25 15V11ZM20.5 9.75C21.1904 9.75 21.75 10.3096 21.75 11V15C21.75 15.6904 21.1904 16.25 20.5 16.25H19.25V9.75H20.5Z",
    fill: "#001D3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 21.5C14.1046 21.5 15 20.6046 15 19.5C15 18.3954 14.1046 17.5 13 17.5C11.8954 17.5 11 18.3954 11 19.5C11 20.6046 11.8954 21.5 13 21.5ZM13 23C14.933 23 16.5 21.433 16.5 19.5C16.5 17.567 14.933 16 13 16C11.067 16 9.5 17.567 9.5 19.5C9.5 21.433 11.067 23 13 23Z",
    fill: "#001D3D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4955 17.6446C19.6454 17.3828 19.75 17.0192 19.75 16.5L21.25 16.5C21.25 17.2234 21.1028 17.8562 20.7972 18.3899C20.49 18.9265 20.0494 19.3162 19.5381 19.592C18.5491 20.1256 17.2619 20.25 16 20.25L16 18.75C17.2234 18.75 18.1862 18.617 18.8259 18.2719C19.1289 18.1084 19.3473 17.9035 19.4955 17.6446Z",
    fill: "#001D3D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.7c2f9acfd470b8fcd457baecf34095be.svg";
export { ForwardRef as ReactComponent };